export default __webpack_public_path__ + "static/media/debts_and_liabilities.9affb5b2.svg";